import {FormatDateOptions} from 'react-intl';

export function toCreatedAtDate(value: string | null | undefined): Date | null {
	return value ? new Date(value) : null;
}

export const CREATED_AT_TIME_ZONE_OPTIONS: FormatDateOptions = {timeZoneName: 'short'};
